import { Theme } from '@mui/material'

const useStyles = {
  verifyText: (isMobile: boolean) => ({
    textAlign: 'left',
    width: '100%',
    marginTop: isMobile ? 4 : 0,
    marginBottom: isMobile ? 2 : 0,
    paddingLeft: isMobile ? 0 : 1,
  }),
  accountProtectText: {
    marginBottom: 1,
  },
  passwordMustTitle: (isMobile: boolean) => ({
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    textAlign: 'left',
    width: '100%',
    marginTop: isMobile ? 2 : 0,
    marginBottom: isMobile ? 1 : 0,
  }),
  requirementsList: (theme: Theme) => ({
    margin: 0,
    paddingLeft: '20px',
    width: '100%',
    '& li': {
      color: theme.palette.text.secondary,
      marginBottom: theme.spacing(1),
    },
  }),
  requirementItem: (theme: Theme) => ({
    color: theme.palette.text.secondary,
    fontSize: '16px',
  }),
}

export default useStyles
